export const tel = '+905443669808'
export const telText = '0544 366 98 08'
